/*
 * @Author: chenyan
 * @Date: 2017-12-19 11:02:02
 * @Description: vuex user
 * @Last Modified by: wanghf
 * @Last Modified time: 2025-11-05 15:45:17
 */

import api from '@/api/index'
import { fetchUserInfo } from '@/api/modules/user'
import store from '@/vuex'
import tools from '@/lib/tools'
// const error404 = () => import('@/views/error/error404.vue')
const error404 = resolve => require(['@/views/error/error404.vue'], resolve) // 404页面

// 获取主站免登链接
import { queryRelateAccounts, getAutoLoginAddress, getAutoLoginCurrentsAddress } from '@/api/modules/cashAccount'
// 查询当前商户是否开放支付链功能
import { paymentLinkPermission } from '@/api/modules/paymentLink'

const actions = {
	/**
   * 判断是否拿到用互信息
   */
	point: async({ commit, dispatch, rootGetters, state }, { to, from, router }) => {
		const result = {
			redirectPath: '',
			needRematch: false
		}
		if (!rootGetters['user/accountCenterInfo'].clientId) {
			const bool = state.route.includes(to.path)
			if (!bool) {
				// 是否已获取用户信息
				await dispatch('user/getAccountCenterInfo', null, {
					root: true
				})

				await dispatch('user/setGrayReleasePermission', null, {
					root: true
				})

				// 商户证件信息是否过期 - 过期需弹窗提醒
				await dispatch('personCertification/getCertificationInfo', null, {
					root: true
				})

				const hasPermissionRoutes = await store.dispatch('asyncRoutesQuery')
				if (hasPermissionRoutes) {
					// 首次登录时，当前目标页在进入守卫前已经按旧路由表匹配过一次。
					// 动态路由补齐后，需要由外层守卫按当前目标地址再重进一次。
					router.addRoutes(rootGetters['routes'])
					router.addRoutes([{
						path: '*',
						component: error404
					}])
					commit('SET_POST_LOGIN_INIT_PENDING', true)
					result.needRematch = true
					return result
				}
				// 判断登录页token没失效自己进入
				if (to.path === '/aq/login' && rootGetters['user/accountCenterInfo'].clientId) {
					// 获取用户配置信息
					result.redirectPath = '/aq/websiteList'
					return result
				}
				// dispatch('buriedPoint')
			}
		}

		return result
	},
	postLoginInit: async({ commit, dispatch }) => {
		await Promise.all([
			dispatch('queryRelateAccounts'),
			dispatch('user/showNewIcon', null, {
				root: true
			}),
			dispatch('paymentLinkPermission')
		])
		commit('SET_POST_LOGIN_INIT_PENDING', false)
	},
	/**
   * 埋点数据发送
   */
	buriedPoint: async({ commit }) => {
		const urlParams = window.location.href.indexOf('?') > 0 ? '?' + window.location.href.split('?')[1] : ''
		const clientId = store.getters['user/accountCenterInfo'].clientId
		const uuid = tools.generateUUID()
		const params = {
			domain: window.location.host,
			url: window.location.href,
			params: urlParams,
			uid: clientId,
			refer: document.referrer,
			cookieid: uuid,
			agent: window.navigator.userAgent || '',
			os: tools.detectOS(),
			language: window.navigator.language,
			type: 'route',
			typeName: '路由跳转'
		}
		// console.info('埋点参数',params)
		// const data = await api.buriedPoint(params)

		// if (!data) {
		// 	console.log('=========post buriedPoint failed!=========')
		// }
	},

	queryRelateAccounts: async({ commit }) => {
		const data = await queryRelateAccounts()
		if (data) {
			const { vaAccountRelated, currentsAccountRelated } = data
			commit('getVaAccountRelated', vaAccountRelated)
			commit('getCurrentsAccountRelated', currentsAccountRelated)
		}
	},
	// 获取主站免登链接
	autoLoginAddress: async({ commit }) => {
		const data = await getAutoLoginAddress({
			clientId: store.getters['user/accountCenterInfo'].clientId
		})
		if (data) {
			commit('getPingpongLink', data)
		}
	},

	// 获取Currents免登链接
	autoLoginCurrentsAddress: async({ commit }) => {
		const data = await getAutoLoginCurrentsAddress({
			clientId: store.getters['user/accountCenterInfo'].clientId
		})
		if (data) {
			commit('getCurrentsLink', data)
		}
	},
	// 查询当前商户是否开放支付链功能
	paymentLinkPermission: async({ commit }) => {
		const data = await paymentLinkPermission()
		if (data) {
			commit('paymentLinkPermission', data)
		}
	},
	checkTradeType: async({ commit }) => {
		const r = await fetchUserInfo()
		commit('SET_TRADE_TYPE', r)
		return new Promise(resolve => {
			resolve(r)
		})
	}
}

const state = {
	route: [
		'/', // 官网首页
		'/product/card-payment', // 卡支付
		'/product/subscription-payment', // 订阅支付
		'/product/bnpl-payment', // 先买后付
		'/product/payment-pricing', // 标准报价
		'/product/payment-link', // 链接支付
		'/product/payment-link-demo', // 链接支付demo
		'/product/dcc', // DCC
		'/solutions/ecommerce', // 电商
		'/solutions/digital-businesses', // 游戏
		'/product/preview', // demo页面
		'/payment-link-checkout',
		'/contact', // 联系我们
		'/cookie-policy', // cookie政策
		'/aq/login',
		'/aq/authLogin',
		'/aq/authSelectRegion',
		'/aq/forgetPwd',
		'/aq/register',
		'/aq/account-create',
		'/aq/setNewPwd',
		'/aq/resetPwd',
		'/error404',
		'/agreement',
		'/agreement-v2',
		'/serviceAgreement',
		'/admin/whoisyourdaddy',
		'/paymentLink',
		'/paymentLinkV2',
		'/paymentLinkV3',
		'/payment404',
		'/authFail',
		'/aq/faq',
		'/aq/contact',
		'/aq/pay/demoStore',
		'/mobile/faq',
		'/mobile/faq/detail',
		'/springAirlines'
	],
	pingpongLink: false,
	currentsLink: false,
	vaAccountRelated: false,
	currentsAccountRelated: false,
	paymentLinkPermission: null,
	tradeType: { industryType: '' },
	postLoginInitPending: false,
	isFromOmnichannel: false // 是否是新消费场景 industryType = Service/Goods
}

const mutations = {
	getVaAccountRelated(state, data) {
		state.vaAccountRelated = data
	},
	getCurrentsAccountRelated(state, data) {
		state.currentsAccountRelated = data
	},
	getPingpongLink(state, data) {
		const _data = _.cloneDeep(data)
		if (_data === 'Not Related') {
			state.pingpongLink = false
		} else {
			state.pingpongLink = _data.autoLoginUrl
		}
	},
	getCurrentsLink(state, data) {
		const _data = _.cloneDeep(data)
		if (_data === 'Not Related') {
			state.currentsLink = false
		} else {
			state.currentsLink = _data
		}
	},
	paymentLinkPermission(state, data) {
		state.paymentLinkPermission = _.cloneDeep(data)
	},
	SET_TRADE_TYPE(state, type) {
		state.tradeType = type
	},
	SET_POST_LOGIN_INIT_PENDING(state, pending) {
		state.postLoginInitPending = pending
	}
}

const getters = {
	pingpongLink: state => state.pingpongLink,
	currentsLink: state => state.currentsLink,
	paymentLinkPermission: state => state.paymentLinkPermission,
	vaAccountRelated: state => state.vaAccountRelated,
	currentsAccountRelated: state => state.currentsAccountRelated,
	postLoginInitPending: state => state.postLoginInitPending
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
